import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { cleanLanguagePrefixes, fixGameRoute } from '@/utils/urlCleaner';

/**
 * Composant qui gère les redirections d'URL pour corriger les problèmes SEO
 * - Redirige /games/ vers /game/
 * - Nettoie les préfixes de langue empilés
 * - Normalise les URLs problématiques
 */
export const URLRedirectManager = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname;
    let shouldRedirect = false;
    let newPath = currentPath;

    // 1. Corriger /games/ vers /game/
    if (currentPath.includes('/games/')) {
      newPath = fixGameRoute(newPath);
      shouldRedirect = true;
    }

    // 2. Nettoyer les préfixes de langue empilés
    if (currentPath.match(/\/(?:fr|en|es).*\/(?:fr|en|es)/)) {
      const cleanPath = cleanLanguagePrefixes(currentPath);
      // Reconstruire avec le bon préfixe selon la première langue détectée
      const firstLangMatch = currentPath.match(/^\/?(fr|en|es)/);
      if (firstLangMatch && firstLangMatch[1] !== 'fr') {
        newPath = `/${firstLangMatch[1]}${cleanPath === '/' ? '' : cleanPath}`;
      } else {
        newPath = cleanPath;
      }
      shouldRedirect = true;
    }

    // 3. Effectuer la redirection si nécessaire
    if (shouldRedirect && newPath !== currentPath) {
      //console.log('🔄 URL Redirect:', { from: currentPath, to: newPath });
      navigate(newPath, { replace: true });
    }
  }, [location.pathname, navigate]);

  return null;
};